// extracted by mini-css-extract-plugin
module.exports = {"customAutocomplete":"Autocomplete_customAutocomplete__1U9Yc"};